import React from "react";
import ImageV2 from "src/components/image/image.v2";
import Link from "src/components/link";

type LogosItemProps = {
    name: string;
    src: string;
    href: string;
}

export default class LogosItem extends React.Component<LogosItemProps> {
    render(): React.ReactNode {
        return <div className="relative col-span-1 flex justify-center py-8 px-4">
            <Link className="" href={this.props.href} title={this.props.name}>
                <ImageV2 className="w-40 max-h-[70px]" src={this.props.src} alt={this.props.name} />
            </Link>
        </div>;
    }
}